export const CATEGORY_COLORS = {
    red: "#e84545",
    orange: "#f5a142",
    yellow: "#fbe27a",
    purple: "#a259c4",
    blue: "#5a9bd4",
    gray: "#9aa0a6",
    green: "#52c41a",
    default: "#fbb040",
}

export const FLAG_SEVERITY = ["red", "orange", "yellow", "purple", "blue", "gray", "green", "default"]

export const FLAG_CONFIG = {
    current_charges_flag: { category: "red", external: true },
    balance_forward_flag: { category: "orange", external: true },
    late_fee_flag: { category: "yellow", external: true },
    due_date_flag: { category: "purple", external: true },
    amount_paid_flag: { category: "blue", external: true },
    amount_due_flag: { category: "blue", external: true },
    group_bill_total_flag: { category: "gray", external: true },
    group_bill_missing_flag: { category: "gray", external: true },
    previous_reading_flag: { category: "green", external: true },
    previous_read_date_flag: { category: "green", external: true },
    estimated_flag: { category: "green", external: true },
    negative_usage_flag: { category: "green", external: true },
    bill_date_flag: { category: "default", external: true },
    multiplier_flag: { category: "green", external: true },
    negative_number_of_days_flag: { category: "green", external: true },
    usage_flag: { category: "green", external: true },
    number_of_days_flag: { category: "green", external: true },
}

const DEFAULT_META = { category: "default", external: true }

export function getFlagMeta(flagKey) {
    const entry = FLAG_CONFIG[flagKey] || DEFAULT_META
    return { ...entry, color: CATEGORY_COLORS[entry.category] }
}

export function filterFlagsByAudience(flagsObj, audience) {
    if (!flagsObj) return {}
    if (audience !== "external") return { ...flagsObj }
    const result = {}
    for (const key of Object.keys(flagsObj)) {
        if (flagsObj[key] && getFlagMeta(key).external) {
            result[key] = flagsObj[key]
        }
    }
    return result
}

export function groupFlagsByCategory(flagsObj) {
    if (!flagsObj) return []
    const buckets = {}
    for (const key of Object.keys(flagsObj)) {
        const message = flagsObj[key]
        if (!message) continue
        const meta = getFlagMeta(key)
        if (!buckets[meta.category]) {
            buckets[meta.category] = { category: meta.category, color: meta.color, items: [] }
        }
        buckets[meta.category].items.push({ key, message })
    }
    return FLAG_SEVERITY.filter((cat) => buckets[cat]).map((cat) => buckets[cat])
}
